export default "/images/vendor/@coreui/icons/svg/flag/cif-md.svg?c21708cb31f14480d52eaa10f26d5ece";